import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { AuthUserInfoModel } from '../../models/auth-user-info-model';
import { environment } from '../../../environments/environment';
import { MyAccountService } from '../../services/my-account.service';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-head',
  templateUrl: './head.component.html',
  styleUrls: ['./head.component.css'],
})
export class HeadComponent implements OnInit {
  user: AuthUserInfoModel;
  showLogo: boolean;
  showMfaHint: boolean;

  constructor(
    private myAccountService: MyAccountService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    ) { }

  ngOnInit() {
    this.loadUser();

    this.myAccountService.missionAnnounced$.subscribe(mission => {
      this.loadUser();
    });

  }

  loadUser() {
    this.myAccountService.getCurrentUser().subscribe(result => {
      this.user = result;
      this.user.logoUrl = environment.apiUrl + result.logoFileName;
      this.showLogo = result.logoFileName != null;
    });
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
  manageAccount() {
    this.router.navigate(['/account']);
  }

  goToSetupTotp() {
    this.router.navigate(['/my-account/activate-totp']);
  }
}
